import { AbstractValidator } from './abstract-validator';

export class PatternValidator extends AbstractValidator {
    static getIdentifier() {
        return 'pattern';
    }
    static isApplicable(input, validationInstance) {
        return super.isApplicable(input, validationInstance) &&
            input.hasAttribute('pattern');
    }
    static validate(input) {
        return (onError, onSuccess) => {
            const pattern = new RegExp(input.getAttribute('pattern'));
            const value = input.value;
            if (pattern.test(value)) {
                onSuccess();
            } else {
                onError();
            }
        };
    }
}